/**
 * Slug router — reads the URL slug param, parses it, and renders the
 * appropriate SEO template (parent service or service+city). If the slug
 * does not match a known service or service+city combination, we render
 * a not-found that redirects home (no 404 stylings — we don't want soft
 * 404s in production).
 *
 * IMPORTANT: this is mounted at the END of the route table in App.js so
 * specific routes (/, /admin, /booking, /customer/*, /driver/*, etc) always
 * win the match. Only after no specific route matches does the SEO router
 * get a chance to claim the URL.
 */
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { parseSlug } from "../lib/slugs";
import ServiceLandingTemplate from "../templates/ServiceLandingTemplate";
import ServiceLocationTemplate from "../templates/ServiceLocationTemplate";

export default function SeoSlugRouter() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const parsed = parseSlug(slug);

  useEffect(() => {
    if (!parsed) {
      // Unknown slug — silently redirect to home (no soft 404 hangs).
      navigate("/", { replace: true });
    }
  }, [parsed, navigate]);

  if (!parsed) return null;
  if (parsed.city) {
    return <ServiceLocationTemplate service={parsed.service} city={parsed.city} />;
  }
  return <ServiceLandingTemplate service={parsed.service} />;
}
